import { inject, Injectable } from '@angular/core';
import { ArticleItem } from '../models/article-item.model';
import { ArticleDataMapper } from '../mappers/article-data.mapper';
import { GuidGeneratorService } from '@shared/tools/guid-generator.service';
import { HsBlazorService } from '@hsetu/core-services';

@Injectable({
  providedIn: 'root',
})
export class ArticleItemService {
  private readonly _serviceKey = 'kfmItem';
  private readonly _blazorService = inject(HsBlazorService);
  private readonly _mapper = new ArticleDataMapper();
  private readonly _guidGenerator = inject(GuidGeneratorService);

  public async createOrUpdate(
    value: ArticleItem,
  ): Promise<ArticleItem | undefined> {
    const request = this._mapper.mapPutItemRequest(value);
    const result = await this._blazorService.invokeService(
      this._serviceKey,
      'Put',
      request,
    );

    if (result) {
      const id = (result as Record<string, unknown>)['id'] as string;
      value.uId = id;
      return value;
    }

    return undefined;
  }

  public async update(value: ArticleItem): Promise<boolean> {
    const request = this._mapper.mapPutItemRequest(value);
    const result = await this._blazorService.invokeService(
      this._serviceKey,
      'Put',
      request,
    );

    if (result) return true;
    return false;
  }

  public async delete(id: string): Promise<boolean> {
    const result = await this._blazorService.invokeService(
      this._serviceKey,
      'Delete',
      { id: id },
    );

    return !!result;
  }

  public getTemplate(isTextPosition = false): ArticleItem {
    const item: ArticleItem = {
      uId: this._guidGenerator.emptyUUID,
      infoDesc: '',
      unit: isTextPosition ? '' : 'Stk',
      articleNumber: isTextPosition ? 'Text' : '',
      manufacturerLabel: '',
      amount: 0,
      sortNum: -1,
      stampCreate: new Date().toISOString(),
      concurrencyIdentificator: this._guidGenerator.emptyUUID,
      concurrencyStamp: new Date().toISOString(),
      syncType: 1,
      tenantUId: this._guidGenerator.emptyUUID,
      userUId: this._guidGenerator.emptyUUID,
      taskId: this._guidGenerator.emptyUUID,
    };

    return item;
  }
}
